import * as THREE from 'three';
import { PLANET_R } from '../config.js';

// A backside sphere that renders a fresnel glow around the planet's silhouette.
// Additive blending so it reads as light against the starfield. `fog: true` is
// ignored by ShaderMaterial (needs manual shader work), which we want.
export function createAtmosphere() {
  const geometry = new THREE.SphereGeometry(PLANET_R * 1.25, 48, 48);
  const material = new THREE.ShaderMaterial({
    transparent: true,
    side: THREE.BackSide,
    blending: THREE.AdditiveBlending,
    depthWrite: false,
    vertexShader: /* glsl */`
      varying vec3 vN;
      void main() {
        vN = normalize(normalMatrix * normal);
        gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
      }`,
    fragmentShader: /* glsl */`
      varying vec3 vN;
      void main() {
        float f = pow(1.0 - abs(vN.z), 3.0);
        gl_FragColor = vec4(0.35, 0.65, 1.0, f * 0.55);
      }`,
  });
  return new THREE.Mesh(geometry, material);
}
